import * as Api from '@ViewModels';

interface MeetingUrlBuilderOptions {
	contactId: string;
	selectedUserId?: string;
}

/**
 * Builds a meeting URL for contact booking, optionally for a specific user (admin functionality)
 */
export function buildMeetingUrlForContact(
	meetingConfig: Api.MeetingConfigViewModel,
	options: MeetingUrlBuilderOptions
): string | null {
	if (!meetingConfig?.link || !meetingConfig.shortCode) {
		return null;
	}

	const { contactId, selectedUserId } = options;

	// If no specific user is selected, use the meeting config owner's URL
	if (!selectedUserId) {
		// Use the same pattern as QuickActions component
		const url = meetingConfig.link.replace(
			`${meetingConfig.shortCode}/${meetingConfig.vanityPath}`,
			`${meetingConfig.shortCode}?landing=true&contactId=${contactId}`
		);
		return url;
	}

	// For admin functionality, we need to construct URL for the selected user
	// The meeting config belongs to the selected user, so we use their shortCode
	const baseUrl = meetingConfig.link.replace(
		`${meetingConfig.shortCode}/${meetingConfig.vanityPath}`,
		`${meetingConfig.shortCode}?landing=true&contactId=${contactId}`
	);

	return baseUrl;
}

/**
 * Gets the first published meeting config for a user
 */
export function getFirstPublishedMeetingConfig(
	meetingConfigs: Api.MeetingConfigViewModel[] | undefined
): Api.MeetingConfigViewModel | null {
	if (!meetingConfigs) return null;
	return meetingConfigs.filter(config => config.isPublished)?.[0] || null;
}
